module.exports = __webpack_public_path__ + "images/close-78af49.svg";